import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';

export const menusApi = createApi({
    reducerPath: 'menus',
    baseQuery: createBaseQueryWithReauth('/menus'),

    tagTypes: ['Menus'],

    endpoints: builder => ({
        getMenus: builder.query({
            query: (shop_id) => ({
                url: `/list${shop_id ? `?shop_id=${shop_id}` : ''}`,
                method: 'GET',
            }),
            providesTags: ['Menus'],
         keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            refetchOnFocus: true,
            refetchOnReconnect: true,
        }),

        createMenu: builder.mutation({
            query: ({ shop_id, ...data }) => ({
                url: `/create?shop_id=${shop_id}`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Menus'],
        }),

        updateMenu: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `/update?id=${id}`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Menus'],
        }),

        deleteMenu: builder.mutation({
            query: (id) => ({
                url: `/delete?id=${id}`,
                method: 'POST',
            }),
            invalidatesTags: ['Menus'],
        }),
    }),
});

export const {
    useGetMenusQuery,
    useCreateMenuMutation,
    useUpdateMenuMutation,
    useDeleteMenuMutation,
} = menusApi;